import { QueryClient } from "@tanstack/react-query";

const MAX_RETRIES = 3;

const isClientError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null || !("status" in error)) {
    return false;
  }
  const { status } = error;
  return typeof status === "number" && status >= 400 && status < 500;
};

// Настройки Query по умолчанию задаются только здесь (см. app/rules.md).
// GET повторяется до трёх раз с растущей задержкой, кроме ответов 4xx.
// Ошибка с полем `status` — договорённость с клиентом из shared/api.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => !isClientError(error) && failureCount < MAX_RETRIES,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
    mutations: {
      retry: false,
    },
  },
});
